import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import axios from 'axios';
import ThumbNail from './ThumbNail';
import { changeMedia } from '../../redux/mediaSlice';
 
const Media = () => {
  const dispatch = useDispatch();
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    pauseOnHover: true,
    swipe: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    loadMedia();
  }, []);

  const loadMedia = async () => {
    try {      
      const res = await axios.get(`${process.env.REACT_APP_API_PATH}media/public`,{
        params: {
          page: 1,
          size:10000
        }
      });
      const { error, data } = res.data;

      if (!error && Array.isArray(data) && data.length > 0) {
        setMedia(data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

const handleImageClick = (item) => {    
    dispatch(changeMedia(item));
     window.scrollTo({ top: 0, behavior: 'smooth' }); // ✅ Correct
  };

  if(media.length < 1){
    return '';
  }

  return (
    <div style={{ maxWidth: '1100px', margin: 'auto', padding: '2rem' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>Media</h2>

      {loading ? (
        <p style={{ textAlign: 'center' }}>Loading...</p>
      ) : media.length === 0 ? (
        <p style={{ textAlign: 'center' }}>No media found.</p>
      ) : (
        <>
          <style>
            {`
              .slick-prev:before,
              .slick-next:before {
                color: black !important;
                font-size: 30px !important;
                opacity: 1 !important;
              }

              .slick-prev,
              .slick-next {
                z-index: 10 !important;
                display: block !important;
              }

              .slick-track {
                display: flex !important;
              }

              .slick-slide {
                height: inherit !important;
                display: flex !important;
                justify-content: center;
              }

              .slick-slide > div {
                display: flex;
              }
            `}
          </style>

          <Slider {...settings}>
            {media.map((item, index) =>  <ThumbNail 
                key={index}
                item={item} 
                index={index} 
                handleImageClick={handleImageClick} 
              /> 
            )}            
          </Slider>
        </>
      )}
    </div>
  );
};

export default Media;